import React from 'react';
import { createPortal } from 'react-dom';
import { Spin } from 'antd';

const LoadingOverlay = ({ visible, message = 'Exporting...', backgroundColor = '#FFFFFF', usePortal = true, showBackground = true }) => {
  if (!visible) return null;

  const overlayContent = (
    <div
      style={{
        position: usePortal ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: showBackground ? backgroundColor : 'transparent',
        backdropFilter: showBackground ? 'blur(10px)' : 'none',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size="large" />
      <div style={{
        marginTop: 20,
        fontSize: 16,
        color: '#262626',
        fontFamily: 'Plus Jakarta Sans',
        fontWeight: 500,
      }}>
        {message}
      </div>
    </div>
  );

  return usePortal ? createPortal(overlayContent, document.body) : overlayContent;
};

export default LoadingOverlay;
